<template>
    <ul class="rating">
        <li class="rating-item flex justify-between pb-spc6 ">
            <span class="rating-title text-14 font-bold text-dark_gray">
                Driver
                <span class="stitle text-size8 block font-medium">Frontal</span>
            </span>
            <div class="rating-icon">
                <span class="text-size17 tracking-widest text-dark_gray">★</span>
                <span class="text-size17 tracking-widest text-dark_gray">★</span>
                <span class="text-size17 tracking-widest text-dark_gray">★</span>
                <span class="text-size17 tracking-widest text-dark_gray">★</span>
                <span class="text-size17 tracking-widest text-dark_gray">★</span>
            </div>
        </li>
        <li class="rating-item flex justify-between pb-spc6 ">
            <span class="rating-title text-14 font-bold text-dark_gray">
                Passenger
                <span class="stitle text-size8 block font-medium">Frontal</span>
            </span>
            <div class="rating-icon">
                <span class="text-size17 tracking-widest text-dark_gray">★</span>
                <span class="text-size17 tracking-widest text-dark_gray">★</span>
                <span class="text-size17 tracking-widest text-dark_gray">★</span>
                <span class="text-size17 tracking-widest text-dark_gray">★</span>
                <span class="text-size17 tracking-widest text-dark_gray">★</span>
            </div>
        </li>
        <li class="rating-item flex justify-between pb-spc6 ">
            <span class="rating-title text-14 font-bold text-dark_gray">
                Front Seat
                <span class="stitle text-size8 block font-medium">Side</span>
            </span>
            <div class="rating-icon">
                <span class="text-size17 tracking-widest text-dark_gray">★</span>
                <span class="text-size17 tracking-widest text-dark_gray">★</span>
                <span class="text-size17 tracking-widest text-dark_gray">★</span>
                <span class="text-size17 tracking-widest text-dark_gray">★</span>
                <span class="text-size17 tracking-widest text-dark_gray">★</span>
            </div>
        </li>
        <li class="rating-item flex justify-between pb-spc6 ">
            <span class="rating-title text-14 font-bold text-dark_gray">
                Rear Seat
                <span class="stitle text-size8 block font-medium">Side</span>
            </span>
            <div class="rating-icon">
                <span class="text-size17 tracking-widest text-dark_gray">★</span>
                <span class="text-size17 tracking-widest text-dark_gray">★</span>
                <span class="text-size17 tracking-widest text-dark_gray">★</span>
                <span class="text-size17 tracking-widest text-dark_gray">★</span>
                <span class="text-size17 tracking-widest text-dark_gray">★</span>
            </div>
        </li>
        <li class="rating-item flex justify-between pb-spc6 ">
            <span class="rating-title text-14 font-bold text-dark_gray">
                Rollover
            </span>
            <div class="rating-icon">
                <span class="text-size17 tracking-widest text-dark_gray">★</span>
                <span class="text-size17 tracking-widest text-dark_gray">★</span>
                <span class="text-size17 tracking-widest text-dark_gray">★</span>
                <span class="text-size17 tracking-widest text-dark_gray">★</span>
                <span class="text-size17 tracking-widest text-dark_gray">★</span>
            </div>
        </li>
    </ul>
</template>

<script>
    export default {
        name: "RatingOne",
    }
</script>

<style scoped>

</style>